<template>
	<client-only>
		<div class="swiper-outside-container">
			<swiper
				ref="swiper"
				class="swiper pb-12"
				:options="swiperOption"
			>
				<swiper-slide
					v-for="(property, n) in (propertyList && propertyList.length > 0 ? propertyList.slice(0, max) : 8)"
					:ref="`slide${n}`"
					:key="n"
					v-resize="onResize"
				>
					<propertyListItem
						v-if="propertyList && propertyList.length > 0"
						:id="property.id"
						:xs="true"
					/>
					<propertyListItemSkeleton v-else />
				</swiper-slide>
				<div
					slot="pagination"
					class="swiper-pagination py-2"
					:class="{'bullets-white': white}"
				/>
			</swiper>
			<v-btn
				aria-label="Previous property item"
				color="white"
				min-width="52"
				elevation="10"
				class="d-none d-md-flex px-0"
				absolute
				tile
				x-large
				@click="swipePrev"
			>
				<v-icon class="red--text">
					mdi-chevron-left
				</v-icon>
			</v-btn>
			<v-btn
				aria-label="Next property item"
				color="red"
				min-width="52"
				elevation="10"
				class="d-none d-md-flex px-0"
				absolute
				tile
				x-large
				@click="swipeNext"
			>
				<v-icon class="white--text">
					mdi-chevron-right
				</v-icon>
			</v-btn>
		</div>
	</client-only>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import propertyListItemSkeleton from '~/components/2.0/property-list-item-skeleton'
import propertyListItem from '~/components/2.0/property-list-item'

export default {
	components: {
		propertyListItemSkeleton,
		propertyListItem,
		Swiper,
		SwiperSlide
	},

	props: {
		white: {
			type: Boolean,
			default: false
		},
		count: {
			type: Number,
			default: 4
		},
		items: {
			type: Array,
			default: () => []
		},
		list: {
			type: String,
			default: null
		},
		max: {
			type: Number,
			default: 9999
		},
		query: {
			type: Object,
			default: () => null
		},
	},

	data:() => ({
		model: null,
		property: null,
		maxHeight: '100%',

		queryList: null
	}),

	computed: {
		...mapGetters({
			getProperty: 'property/getProperty'
		}),

		swiperOption () {
			let items = 1.2
			/*
			if (this.$vuetify.breakpoint.sm) {
				items = 2.2
			}
			if (this.$vuetify.breakpoint.md) {
				items = 3.5
			}
			if (this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
				items = 4
			}
			*/

			if (this.$vuetify.breakpoint.sm) {
				items = 2.2
			}
			if (process.client && window.innerWidth > 750) {
				items = 3.2
			}
			if (this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
				items = 4
			}

			return {
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					dynamicBullets: true,
					dynamicMainBullets: 3
				},
				centeredSlides: items !== 4,
				centeredSlidesBounds: true,
				// grabCursor: true,
				slidesPerView: items,
				slidesPerGroup: 1,
				spaceBetween: 15,
			}
		},

		propertyList () {
			if (this.list && this.$store.getters[this.list]) {
				return this.$store.getters[this.list].map(item => this.getProperty(item))
			}

			return this.queryList || null
		}
	},

	created() {
		if (process.client && this.query) {
			this.search()
		}
	},

	methods: {
		...mapActions({
			searchProperty: 'property/searchProperty'
		}),

		onResize () {
			this.$nextTick(() => {
				this.maxHeight = this.$refs['slide1'][0].$el.clientWidth * 0.75
			})
		},

		swipePrev () {
			if (this.$refs.swiper.$swiper) {
				this.$refs.swiper.$swiper.slidePrev()
			}
		},
		swipeNext () {
			if (this.$refs.swiper.$swiper) {
				this.$refs.swiper.$swiper.slideNext()
			}
		},

		async search () {
			// Call to store action for search with query (GET parameter)
			let params = {
				ipp: 12, // item per page
				...this.query,
			}

			return this.searchProperty(params).then(propObj => {
				this.queryList = propObj.propsList
			})
		}
	},
}
</script>

<style lang="scss" scoped>
.swiper-outside-container {
	position: relative;

	& > .v-btn--absolute {
		top: 50%;
    right: -52px;
    left: unset;

		&:first-of-type {
			margin-top: -68.5px;
		}
		&:last-of-type {
			margin-top: -16.5px;
		}
	}

	.swiper-pagination::v-deep {
		.swiper-pagination-bullet {
			background-color: #ed1c24;

			&.swiper-pagination-bullet-active::before {
				content: ' ';
				position: absolute;
				top: -2px;
				left: -2px;
				width: 12px;
				height: 12px;
				border: solid 1px #ed1c24;
				border-radius: 50%;
			}
		}

		&.bullets-white {
			.swiper-pagination-bullet {
				background-color: #fff !important;

				&.swiper-pagination-bullet-active::before {
					border-color: #fff !important;
				}
			}
		}
	}

	& ::v-deep .swiper-wrapper {
		height: unset !important;
	}
	& .swiper-slide {
		height: unset !important;
	}
}
</style>
